"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyFormatter = void 0;
/**
 *  Formatter that is used for formatting cents to Euros.
 */
var formatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
/**
 *
 *  Used to format cents to Euros.
 *
 *  @param cents The number of cents to convert to Euros
 *  @param symbol If the Euro symbol should be included
 *
 *  @return The formatted Euro's string
 *
 */
function CurrencyFormatter(cents, symbol) {
    if (symbol === void 0) { symbol = true; }
    var formatted = formatter.format(cents / 100);
    return symbol ? formatted : formatted.replace('€', '');
}
exports.CurrencyFormatter = CurrencyFormatter;
//# sourceMappingURL=index.js.map